import { render } from "./FAIcon.vue?vue&type=template&id=5b08cb4a"
import script from "./FAIcon.vue?vue&type=script&lang=js"
export * from "./FAIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__